import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const SyncNowAction = createAsyncThunk("syncNow",
    async (_, { rejectWithValue }) => {
        try {
            const response = await doGet(urls?.syncNow);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const SyncNowSlice = createSlice({
    name: "syncNow",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        SyncNowReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [SyncNowAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [SyncNowAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [SyncNowAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { SyncNowReset } = SyncNowSlice.actions
export default SyncNowSlice.reducer